import { useState } from "react";
import { browserSupportsWebAuthn } from "@simplewebauthn/browser";
import Button from "@web-ui/components/Button";
import { failureMessage } from "./messages";

/**
 * Runs a passkey ceremony from one button (AnyTV provider console's PasskeyButton). Hidden where
 * the browser cannot do WebAuthn; a closed prompt says nothing; any other failure goes to `onError`.
 */
export function PasskeyButton({ label, run, onError, className }: { label: string; run(): Promise<void>; onError(message: string | null): void; className?: string }) {
  const [busy, setBusy] = useState(false);
  if (!browserSupportsWebAuthn()) return null;
  const click = async () => {
    setBusy(true); onError(null);
    try { await run(); } catch (failure) { onError(failureMessage(failure)); } finally { setBusy(false); }
  };
  return <Button type="button" className={className} variant="outline" icon="lock" isPending={busy} disabled={busy} onClick={() => void click()}>{label}</Button>;
}
